<template>
  <div class="card-guide">
    <div class="card-guide-body">
      <div class="d-flex justify-content-between">
        <span class="col-2 add-tools" @click="showAddAsset(selectedAssetType)">
          + Add
          {{
            selectedAssetType
              ? this.ucFirst(selectedAssetType)
              : selectedAssetType
          }}
        </span>
        <span class="col-2 offset-7">
          <b-form-select
            col="2"
            v-model="selectedAssetType"
            :options="assetTypeOptions"
            @change="handleAssetTypeSelection"
          >
          </b-form-select>
        </span>
        <span class="search">
          <label>
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.3335 3.16659C4.75617 3.16659 2.66683 5.25592 2.66683 7.83325C2.66683 10.4106 4.75617 12.4999 7.3335 12.4999C9.91083 12.4999 12.0002 10.4106 12.0002 7.83325C12.0002 5.25592 9.91083 3.16659 7.3335 3.16659ZM1.3335 7.83325C1.3335 4.51954 4.01979 1.83325 7.3335 1.83325C10.6472 1.83325 13.3335 4.51954 13.3335 7.83325C13.3335 11.147 10.6472 13.8333 7.3335 13.8333C4.01979 13.8333 1.3335 11.147 1.3335 7.83325Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.6284 11.1286C10.8887 10.8683 11.3108 10.8683 11.5712 11.1286L14.4712 14.0286C14.7315 14.289 14.7315 14.7111 14.4712 14.9714C14.2108 15.2318 13.7887 15.2318 13.5284 14.9714L10.6284 12.0714C10.368 11.8111 10.368 11.389 10.6284 11.1286Z"
                fill="#B3C2CB"
              />
            </svg>
            <input
              type="search"
              class="search-input"
              placeholder="Search Forms"
              v-model="searchStr"
            /> </label
        ></span>
      </div>
      <div class="tools" role="tablist">
        <b-card no-body>
          <b-table
            id="table-transition-example"
            :items="selectedAssets"
            :fields="fields"
            small
            primary-key="a"
            :tbody-transition-props="transProps"
            show-empty
          >
            <template #table-busy>
              Busy
            </template>
            <template #empty="scope">
              No Data Available
            </template>
            <template #cell(imgURL)="row">
              <b-avatar
                square
                variant="info"
                :src="row.item.imgURL"
                class="mr-3"
              ></b-avatar>
            </template>
            <template #cell(_created_by)="row">
              <b-col
                variant="info"
                :src="row.item._created_by"
                class="mr-3"
              ></b-col>
            </template>
            <template #cell(actions)="row">
              <div class="actions">
                <b-btn
                  v-if="row.item._hidden_at"
                  variant="outline-primary"
                  class="ml-1 mt-2"
                  size="sm"
                  disabled="disabled"
                >
                  Hidden
                </b-btn>
                <b-btn
                  v-else
                  variant="outline-primary"
                  @click="hideImg(row.item)"
                  :id="'hid' + row.item.assetId"
                  class="ml-1 mt-2"
                  size="sm"
                >
                  {{ hideBtnText }}
                </b-btn>
                <b-btn
                  v-if="row.item._restirceted_at"
                  variant="outline-primary"
                  class="ml-1 mt-2"
                  size="sm"
                  disabled="disabled"
                >
                  Restricted
                </b-btn>
                <b-btn
                  v-else
                  variant="outline-primary"
                  @click="restrictImg(row.item)"
                  :id="'res' + row.item.assetId"
                  class="ml-1 mt-2"
                  size="sm"
                >
                  {{ resBtnText }}
                </b-btn>
              </div>
            </template>
          </b-table>
        </b-card>
        <b-pagination
          v-model="currentPage"
          :total-rows="selectedAssets ? selectedAssets.length : 0"
          :per-page="perPage"
          align="left"
          size="sm"
          class="my-0"
        ></b-pagination>
      </div>
      <modal :id="assetModal">
        <div class="add-company" v-if="true">
          <span class="close-icon" @click="$bvModal.hide(assetModal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>{{ add ? "Add" : "Update" }} {{ this.selectedAssetType }}</h3>
          <div class="h-18"></div>
          <b-form-group label="Upload Journey Assets">
            <div class="upload">
              <div
                class="upload-video"
                v-if="this.selectedAssetType === 'videos'"
              >
                Upload your Video
              </div>
              <div>
                <b-button
                  v-if="this.selectedAssetType === 'videos'"
                  class="upload-btn no-video"
                >
                  <span class="ico">
                    <svg
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M20.048 5.09236C20.3255 5.2352 20.5 5.52118 20.5 5.83334V14.1667C20.5 14.4788 20.3255 14.7648 20.048 14.9076C19.7704 15.0505 19.4363 15.0262 19.1823 14.8448L13.349 10.6781C13.13 10.5217 13 10.2691 13 10C13 9.73088 13.13 9.47832 13.349 9.32189L19.1823 5.15523C19.4363 4.97379 19.7704 4.94953 20.048 5.09236ZM15.2671 10L18.8333 12.5473V7.45266L15.2671 10Z"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M3 4.99967C2.53976 4.99967 2.16667 5.37277 2.16667 5.83301V14.1663C2.16667 14.6266 2.53976 14.9997 3 14.9997H12.1667C12.6269 14.9997 13 14.6266 13 14.1663V5.83301C13 5.37277 12.6269 4.99967 12.1667 4.99967H3ZM0.5 5.83301C0.5 4.4523 1.61929 3.33301 3 3.33301H12.1667C13.5474 3.33301 14.6667 4.4523 14.6667 5.83301V14.1663C14.6667 15.5471 13.5474 16.6663 12.1667 16.6663H3C1.61929 16.6663 0.5 15.5471 0.5 14.1663V5.83301Z"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect
                            width="20"
                            height="20"
                            fill="white"
                            transform="translate(0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span
                    class="btn-content"
                    v-if="this.selectedAssetType === 'videos'"
                    @click="triggerChooseVideo"
                  >
                    Upload a Video
                    <input
                      id="journey-asset-video"
                      type="file"
                      style="visibility: hidden"
                      @change="uploadJourneyAssetVideo"
                    />
                  </span>
                  <!-- <span
                    class="btn-content"
                    v-if="this.selectedAssetType === 'videos'"
                  >
                    <b-spinner small></b-spinner>
                    Uploading... {{ progress }}%
                  </span> -->
                  <!-- <span
                    class="btn-content"
                    v-if="processingVideo && !profile._dashboards.guide.video"
                  >
                    <b-spinner small></b-spinner>
                    Processing Video
                  </span> -->
                  <!-- <span
                    class="btn-content"
                    v-if="
                      profile._dashboards.guide.video &&
                        !profile._dashboards.guide.video.videoThumb
                    "
                  >
                    <b-spinner small></b-spinner>
                    Processing Video
                  </span>
                  <span
                    class="watch-video"
                    v-if="
                      profile._dashboards.guide.video &&
                        profile._dashboards.guide.video.videoId &&
                        profile._dashboards.guide.video.videoThumb
                    "
                  >
                    Watch Video
                  </span> -->
                </b-button>
              </div>
            </div>
            <img
              v-if="imgDataUrl"
              class="assets-image"
              :src="imgDataUrl"
              alt="Company Image"
            />
            <b-link
              v-if="imgDataUrl"
              variant="primary btn-round-fill"
              @click="showUpload = !showUpload"
            >
              Update
            </b-link>

            <b-button
              v-if="this.selectedAssetType === 'images'"
              variant="primary btn-round-fill"
              @click="triggerChooseImage"
            >
              Upload
            </b-button>
            <input
              id="journey-asset-image"
              type="file"
              style="visibility: hidden"
              @change="uploadJourneyAssetImage"
            />
          </b-form-group>
          <my-upload
            langType="en"
            field="img"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            v-model="showUpload"
            :width="600"
            :height="300"
            :params="params"
            :headers="headers"
            img-format="png"
            :noSquare="true"
          >
          </my-upload>
          <b-form-group label="Add Tags Accoringly">
            <span class="add-tags" @click="showAddTag">+ ADD TAG</span>
            <div class="tags">
              <div class="tag" v-for="(tag, i) in tags" :key="i">
                {{ tag.text }}
                <div class="overlay">
                  <svg
                    @click="showEditTag(i)"
                    v-b-popover.top.hover="'Edit Tag'"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.6665 3.33333C2.48969 3.33333 2.32012 3.40357 2.1951 3.5286C2.07008 3.65362 1.99984 3.82319 1.99984 4V13.3333C1.99984 13.5101 2.07007 13.6797 2.1951 13.8047C2.32012 13.9298 2.48969 14 2.6665 14H11.9998C12.1766 14 12.3462 13.9298 12.4712 13.8047C12.5963 13.6797 12.6665 13.5101 12.6665 13.3333V9.77333C12.6665 9.40514 12.965 9.10667 13.3332 9.10667C13.7014 9.10667 13.9998 9.40514 13.9998 9.77333V13.3333C13.9998 13.8638 13.7891 14.3725 13.4141 14.7475C13.039 15.1226 12.5303 15.3333 11.9998 15.3333H2.6665C2.13607 15.3333 1.62736 15.1226 1.25229 14.7475C0.877218 14.3725 0.666504 13.8638 0.666504 13.3333V4C0.666504 3.46957 0.877217 2.96086 1.25229 2.58579C1.62736 2.21071 2.13607 2 2.6665 2H6.2265C6.59469 2 6.89317 2.29848 6.89317 2.66667C6.89317 3.03486 6.59469 3.33333 6.2265 3.33333H2.6665Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.5284 0.86201C11.7888 0.601661 12.2109 0.601661 12.4712 0.86201L15.1379 3.52868C15.3983 3.78903 15.3983 4.21114 15.1379 4.47149L8.47124 11.1382C8.34622 11.2632 8.17665 11.3334 7.99984 11.3334H5.33317C4.96498 11.3334 4.6665 11.0349 4.6665 10.6667V8.00008C4.6665 7.82327 4.73674 7.6537 4.86177 7.52868L11.5284 0.86201ZM5.99984 8.27622V10.0001H7.7237L13.7237 4.00008L11.9998 2.27622L5.99984 8.27622Z"
                      fill="white"
                    />
                  </svg>
                  <svg
                    @click="showDeleteTag(i)"
                    v-b-popover.top.hover="'Delete Tag'"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.3335 3.99992C1.3335 3.63173 1.63197 3.33325 2.00016 3.33325H14.0002C14.3684 3.33325 14.6668 3.63173 14.6668 3.99992C14.6668 4.36811 14.3684 4.66659 14.0002 4.66659H2.00016C1.63197 4.66659 1.3335 4.36811 1.3335 3.99992Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.6665 2.00008C6.48969 2.00008 6.32012 2.07032 6.1951 2.19534C6.07007 2.32037 5.99984 2.48994 5.99984 2.66675V3.33341H9.99984V2.66675C9.99984 2.48994 9.9296 2.32037 9.80457 2.19534C9.67955 2.07032 9.50998 2.00008 9.33317 2.00008H6.6665ZM11.3332 3.33341V2.66675C11.3332 2.13631 11.1225 1.62761 10.7474 1.25253C10.3723 0.877462 9.8636 0.666748 9.33317 0.666748H6.6665C6.13607 0.666748 5.62736 0.877462 5.25229 1.25253C4.87722 1.62761 4.6665 2.13631 4.6665 2.66675V3.33341H3.33317C2.96498 3.33341 2.6665 3.63189 2.6665 4.00008V13.3334C2.6665 13.8638 2.87722 14.3726 3.25229 14.7476C3.62736 15.1227 4.13607 15.3334 4.6665 15.3334H11.3332C11.8636 15.3334 12.3723 15.1227 12.7474 14.7476C13.1225 14.3726 13.3332 13.8638 13.3332 13.3334V4.00008C13.3332 3.63189 13.0347 3.33341 12.6665 3.33341H11.3332ZM3.99984 4.66675V13.3334C3.99984 13.5102 4.07007 13.6798 4.1951 13.8048C4.32012 13.9298 4.48969 14.0001 4.6665 14.0001H11.3332C11.51 14.0001 11.6795 13.9298 11.8046 13.8048C11.9296 13.6798 11.9998 13.5102 11.9998 13.3334V4.66675H3.99984Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </b-form-group>
          <div class="d-flex justify-content-between">
            <b-button
              variant="light btn-simple"
              @click="$bvModal.hide(assetModal)"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary btn-round-fill"
              v-if="add"
              @click="storeImageAndTags"
            >
              Add
            </b-button>

            <b-button
              v-else
              @click="updateImageAndTags"
              variant="primary btn-round-fill"
            >
              Update
            </b-button>
          </div>
        </div>

        <div class="add-company del-company" v-else>
          <span class="close-icon" @click="$bvModal.hide(assetModal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>Delete Company</h3>
          <div class="warning-msg">
            <p>
              Are you sure want to delete
              <!-- <strong v-if="selectedCompany && selectedCompany.company">
                {{ selectedCompany.company.name }}
              </strong> -->
              Company?
            </p>
          </div>
          <!-- <div class="d-flex justify-content-between">
            <b-button variant="danger btn-round-fill" @click="deleteCompany">
              Yes! Delete
            </b-button>
            <b-button variant="light btn-simple" @click="hideDeleteCompany">
              No! back
            </b-button>
          </div> -->
        </div>
      </modal>
      <modal :id="tagModal">
        <div class="add-tag" v-if="!del">
          <span class="close-icon" @click="$bvModal.hide(tagModal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>

          <h3>{{ add ? "Add" : "Edit" }} Tag</h3>
          <div class="h-18"></div>
          <b-form-group>
            <b-form-input
              id="new-tag"
              type="text"
              required
              v-model="tagInput"
              placeholder="Enter your tag here"
              @focus="limitWords"
            ></b-form-input>
            <span class="counter">{{ tagInput.length }}/25</span>
          </b-form-group>

          <div class="d-flex justify-content-between">
            <b-button
              variant="light btn-simple"
              @click="$bvModal.hide(tagModal)"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary btn-round-fill "
              v-if="add"
              @click="addTag"
              :disabled="tagInput.trim().length > 0 ? false : true"
            >
              Add
            </b-button>
            <b-button
              variant="primary btn-round-fill "
              @click="editTag"
              v-else
              :disabled="tagInput.trim().length > 0 ? false : true"
            >
              Update
            </b-button>
          </div>
        </div>
        <div class="add-tag del-tag" v-else>
          <span class="close-icon" @click="$bvModal.hide(tagModal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>Delete Tag</h3>
          <div class="warning-msg">
            <p>
              Are you sure want to delete
              <strong>
                {{ tags[activeIndex].text }}
              </strong>
              tag?
            </p>
          </div>
          <div class="d-flex justify-content-between">
            <b-button variant="danger btn-round-fill " @click="deleteTag">
              Yes! Delete
            </b-button>
            <b-button class="btn-simple" @click="hideDeleteTag">
              No! back
            </b-button>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import firebase from "firebase";
import TimeAgo from "vue2-timeago";
import MyUpload from "vue-image-crop-upload";
import Modal from "@/components/common/modal";
export default {
  components: {
    Modal,
    // TimeAgo,
    MyUpload
  },
  data() {
    return {
      assetToUpdate: "",
      tagModal: "tag-modal",
      tagInput: "",
      activeIndex: -1,
      resBtnText: "Restrict",
      hideBtnText: "Hide",
      add: true,
      allTags: [],
      edit: false,
      del: false,
      assetModal: "admin-assets-modal",
      selectedAssetType: null,
      imgDataUrl: "",
      searchStr: "",
      showUpload: false,
      imgURL: null,
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        smail: "*_~"
      },
      currentPage: 1,
      perPage: 50,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
      selectedUser: null,
      showUserNotify: false,
      transProps: {
        name: "flip-list"
      },
      fields: [
        {
          key: "imgURL",
          label: "Image"
        },
        {
          key: "_created_at",
          label: "Created at",
          sortable: true,
          formatter: "formatDate"
        },
        // {
        //   key: "_created_by",
        //   label: "Created by",
        //   sortable: true
        // }
        { key: "actions", label: "Actions" }
        // { key: "show_details", label: "Details" }
      ]
    };
  },
  mounted() {

  },
  computed: {
    ...mapGetters({
      assetTypes: "assets/assetTypes",
      assets: "assets/assets"
    }),
    tags() {
      // if (this.searchStr.trim() == "")
      return this.allTags;

      // return this.allTags.filter(tag => {
      //   return tag.text
      //     .toLowerCase()
      //     .includes(this.searchStr.toLowerCase().trim());
      // });
    },
    selectedAssets() {
      //console.log("selected assets", this.assets);
      return this.assets[this.selectedAssetType];
    },
    assetTypeOptions() {
      let options = [];
      this.assetTypes.forEach(aAssetType => {
        options.push({
          value: aAssetType.assetId,
          text: this.ucFirst(aAssetType.assetId)
        });
        this.$store.dispatch("assets/getAssetsForType", aAssetType.assetId);
      });
      options.unshift({ value: null, text: "Select Asset Type" });
      return options;
    }
  },
  methods: {
    handleActivation() {
      this.handleGetAssetTypes();
    },
    handleGetAssetTypes(){
      this.$store.dispatch("assets/getAssetTypes");
    },
    hideImg(data) {
      console.log("data", data);
      let btn = document.getElementById("hid" + data.assetId);
      btn.setAttribute("disabled", "true");
      this.hideBtnText = "Hidden";
      this.$store
        .dispatch("admin/restImage", data)
        .then(() => {
          // this.$store.getters["admin/users"];
          this.$store.dispatch("user/showNotification", {
            title: `Image is hidden Now`,
            description: `You have Hide The Image`,
            variant: "success"
          });
        })
        // })
        .catch(error => {
          console.log(error);
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    restrictImg(data) {
      console.log("data", data);
      let btn = document.getElementById("res" + data.assetId);
      btn.setAttribute("disabled", "true");
      this.resBtnText = "Restricted";
      this.$store
        .dispatch("admin/restImage", data)
        .then(() => {
          // this.$store.getters["admin/users"];
          this.$store.dispatch("user/showNotification", {
            title: `Image is Restricted Now`,
            description: `You have Restrict The Image`,
            variant: "success"
          });
        })
        // })
        .catch(error => {
          console.log(error);
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    handleAssetTypeSelection(e) {
      this.selectedAssetType = e;
      console.log("event", e);
      this.$store.dispatch("assets/getAssetsForType", e);
    },
    limitWords() {
      document.getElementById("new-tag").setAttribute("maxlength", 25);
    },
    showAddTag() {
      this.del = false;
      this.add = true;
      (this.tagInput = ""), this.$bvModal.show(this.tagModal);
    },
    triggerChooseVideo() {
      document.getElementById("journey-asset-video").click();
    },
    triggerChooseImage() {
      document.getElementById("journey-asset-image").click();
    },
    uploadJourneyAssetImage(event) {
      let file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = e => {
        this.imgDataUrl = e.target.result;
      };
    },
    uploadJourneyAssetVideo(event) {
      let file = event.target.files[0];
      let name = `journey_asset_${(Date.now() / 1000) | 0}`;
      let description = `Journey Asset Video.`;
      this.uploadVideo(file, name, description).then(video => {
        // this.saveVideo(video);
      });
    },
    saveVideo({ videoName, vimeoURL, videoId, vimeoName }) {
      this.processingVideo = true;
      let dataToUpdate = {
        asset: {
          video: {
            _created_at: new Date(),
            _created_by: "/users/" + this.$store.getters["user/user"].uid,
            videoName,
            vimeoURL,
            videoId,
            vimeoName
          }
        }
      };
      this.$store
        .dispatch("user/updateProfileDashboardGuide", dataToUpdate)
        .then(res => {
          this.getVideoThumbnail(videoId).then(thumbnail => {
            this.$store
              .dispatch("user/updateGuideVideoThumbnail", thumbnail)
              .then(res => {
                this.$store.dispatch("user/getProfile").then(() => {
                  this.processingVideo = false;
                  this.$store.dispatch("user/showNotification", {
                    title: "Video has been uploaded successfully.",
                    description:
                      "Users will not see this info until you Publish.",
                    variant: "success"
                  });
                });
              });
          });
        })
        .catch(e => {
          this.$store.dispatch("user/getProfile");
          this.processingVideo = false;
          console.log(e);
        });
    },
    showEditTag(i) {
      this.del = false;
      this.add = false;
      this.activeIndex = i;
      this.tagInput = this.tags[i].text;
      this.$bvModal.show(this.tagModal);
    },
    showDeleteTag(i) {
      this.del = true;
      this.activeIndex = i;
      this.$bvModal.show(this.tagModal);
    },
    addTag() {
      this.tags.push({
        text: this.tagInput,
        _created_at: new Date(),
        _created_by: "/users/" + this.$store.getters["user/user"].uid
      });
      this.$bvModal.hide(this.tagModal);
      this.tagInput = "";
      // this.saveChanges();
    },
    editTag() {
      this.tags[this.activeIndex].text = this.tagInput;
      this.$bvModal.hide(this.tagModal);
      this.tagInput = "";
      // this.saveChanges();
    },
    deleteTag() {
      this.tags.splice(this.activeIndex, 1);
      this.$bvModal.hide(this.tagModal);
      // this.saveChanges();
    },
    hideDeleteTag() {
      this.$bvModal.hide(this.tagModal);
    },
    saveChanges() {
      let dataToUpdateTags = {
        tags: {
          tags: this.tags
        }
      };

      if (dataToUpdateTags) {
        this.$store
          .dispatch("admin/updateJourneyAssets", dataToUpdateTags)
          .then(res => {
            if (res) {
              this.$store.dispatch("user/showNotification", {
                title: "Tags Updated Successfully",
                description: "Users will not see this info until you Publish.",
                variant: "success"
              });
            }
          });
      }
    },
    formatDate(date) {
      return date ? moment(date.toDate()).format("MMMM DD, YYYY") : "N/A";
    },
    showAddAsset(selectedAssetType) {
      if (selectedAssetType !== null) {
        this.$bvModal.show(this.assetModal);
      }
    },
    showEditAsset(selectedAssetType, asset) {
      console.log("asset", asset);
      this.del = false;
      this.add = false;
      this.edit = true;
      this.reset_form();
      this.imgDataUrl = asset.imgURL;
      this.allTags = asset.tags;
      this.assetToUpdate = asset;
      if (selectedAssetType !== null) {
        this.$bvModal.show(this.assetModal);
      }
    },
    cropSuccess(imgDataUrl, field) {
      this.imgDataUrl = imgDataUrl;
      // this.uploadImage(imgDataUrl);
    },
    cropUploadSuccess(jsonData, field) {
      console.log(jsonData);
      console.log("field: " + field);
    },
    cropUploadFail(status, field) {
      console.log(status);
      console.log("field: " + field);
    },
    ucFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    uploadImage(imgDataUrl, store) {
      let result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < 15; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      var storageRef = firebase.storage().ref(`user_journey_img/${result}`);

      var metadata = {
        contentType: "image/jpeg"
      };
      var uploadTask = storageRef.putString(imgDataUrl, "data_url");

      uploadTask.on(
        "state_changed",
        snapshot => {
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              console.log("Upload is paused");
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              console.log("Upload is running");
              break;
          }
        },
        error => {
          console.log("Error uploading image: ", error);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            console.log(downloadURL);
            this.imgURL = downloadURL;
            this.saveJourneyAsset(this.selectedAssetType);
          });
        }
      );
    },
    saveJourneyAsset(asset_type) {
      let payload = {
        imgURL: this.imgURL,
        _created_at: new Date(),
        _created_by: "/users/" + this.$store.getters["user/user"].uid,
        tags: this.tags
      };
      this.$store
        .dispatch("admin/saveJourneyAsset", { payload, asset_type })
        .then(res => {
          if (res) {
            this.$bvModal.hide(this.assetModal);
            this.reset_form();
            this.$store.dispatch("user/showNotification", {
              title: "Image with tags added Successfully",
              variant: "success"
            });
          }
        });
    },
    storeImageAndTags() {
      let store = true;
      this.uploadImage(this.imgDataUrl, store);
    },
    reset_form() {
      this.imgDataUrl = "";
      this.imgURL = "";
      this.allTags = [];
    }
  }
};
</script>
<style lang="scss" scoped>
.tags {
  display: flex;
  margin-top: 20px;
  flex-wrap: wrap;
  .tag {
    min-width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 16px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 24px;
    margin-right: 16px;
    margin-top: 10px;
    font-size: 14px;
    line-height: 19px;
    align-items: center;
    color: #474d52;
    position: relative;
    .overlay {
      // visibility: hidden;
      opacity: 0;
      border-radius: 24px;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.8);
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      transition: all 0.2s ease-in-out;
      svg {
        cursor: pointer;
      }
    }
    &:hover {
      .overlay {
        opacity: 1;
        // visibility: visible;
      }
    }
  }
}

.add-tools {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.actions {
  display: flex;
}
.add-tags {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.assets-image {
  width: 80px;
  height: 80px;
  border-radius: 10%;
}
.add-tool {
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  input {
    margin-top: 48px;
    margin-bottom: 30px;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.upload {
  margin-bottom: 1rem;
  .upload-video {
    margin-top: 15px;
    font-family: Nunito;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    color: #8d99a0;
  }
  .upload-btn {
    margin-top: 16px;
    width: 208px;
    height: 40px;
    border-radius: 100px;
    border: none;
    outline: none !important;
    .ico {
      margin-right: 5px;
    }
    .btn-content {
      margin-top: 5px;
      font-family: Nunito;
      margin-left: -38px;
      font-style: normal;
      font-weight: 800;
      font-size: 16px;
      line-height: 22px;
      color: var(--theme-color);
    }
  }
  .video {
    color: #fff !important;
    background-color: var(--theme-color) !important;
  }
  .no-video {
    color: var(--theme-color);
    background: rgba(85, 126, 251, 0.1);
  }
  .watch-video {
    margin-top: 5px;
    font-family: Nunito;
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
  }
}
.del-tool {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.tools {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
      .btn-collapse {
        padding-bottom: 0px;
      }
    }
    border: none;
    box-shadow: none;
    background: none;
  }
  .add-tag {
    .close-icon {
      position: absolute;
      top: 24px;
      right: 20px;
      cursor: pointer;
    }
    .btn-round-fill {
      max-width: 160px;
      width: 100%;
    }
    input {
      margin-top: 48px;
      margin-bottom: 30px;
    }
    h3 {
      margin-bottom: 0;
      margin-top: 10px;
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 33px;
      color: #474d52;
      text-align: center;
    }
  }
  .del-tag {
    .warning-msg {
      margin: 24px 0;
      p {
        text-align: center;
        margin: 0;
      }
    }
    .btn-round-fill {
      background-color: #ef5c4a;
      border-color: #ef5c4a;
    }
    .btn-simple {
      color: #ef5c4a;
      font-weight: bold;
    }
  }
}
.counter {
  margin-top: -18px;
  margin-right: 5px;
  font-size: 12px;
  float: right;
}
</style>
